import type { IdentityInfo } from "owa-auth-types";
import setAccountAuthState from "./setAccountAuthState";
import { StateTypeEnum } from "../store/schema/AccountAuthState";

/**
 * Marks the identity as removed in the current session. This is used when the user removes an account
 * that requires a restart.
 * @param identityInfo The identity info of the account to mark as removed in session
 */
export default function markIdentityAsRemovedThisSession(identityInfo: IdentityInfo): void {
    setAccountAuthState(identityInfo, {
        stateType: StateTypeEnum.AuthError,
        errorData: {
            timeStamp: Date.now(),
            error: "Account removed from session",
        },
        isReplacedInSession: true,
    });
}
